
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AlertService } from '../alert/alert.service';
import { ProfileService } from '../profile/profile.service';
import { Storage } from '@ionic/storage';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    protected auth: AuthService,
    protected alert: AlertService,
    protected profile: ProfileService,
    protected storage: Storage,
    protected router: Router,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    
    try {
      const loggedIn = await this.auth.isLoggedIn();

      if (!loggedIn) {
        // if (this.router.url.slice(0, 11) === '/find-carry' || this.router.url.slice(0, 10) === '/find-send') {
        //   await this.storage.set('lastUserSearch', this.router.url);
        // }
        await this.storage.set('lastUserSearch', this.router.url);

        await this.alert.showAlertEnterSignup();
        return false;
      }

      if (state.url !== '/profile') {
        const user = await this.profile.getProfile();
        if (!user) {
          await this.alert.redirect(['/profile'], null, 'GUARD_PROFILE');
          return false;
        }
      }

      return true;

    } catch (err) {
      await this.alert.translate('GUARD_LOGGEDIN');
      return false;
    }

  }
}